import { FormSelectItem } from "../../../../Blocks/ProvetOnlineBooking/types";

export const CountryCodeSelectItems: FormSelectItem[] = [
  { caption: "افغانستان", value: "+93", categoryValue: "fa-AF" },
  { caption: "Shqipëri", value: "+355", categoryValue: "sq-AL" },
  { caption: "الجزائر", value: "+213", categoryValue: "ar-DZ" },
  { caption: "Andorra", value: "+376", categoryValue: "ca-AD" },
  { caption: "Angola", value: "+244", categoryValue: "pt-AO" },
  { caption: "Argentina", value: "+54", categoryValue: "es-AR" },
  { caption: "Հայաստան", value: "+374", categoryValue: "hy-AM" },
  { caption: "Australia", value: "+61", categoryValue: "en-AU" },
  { caption: "Österreich", value: "+43", categoryValue: "de-AT" },
  { caption: "Azərbaycan", value: "+994", categoryValue: "az-AZ" },
  { caption: "Bahamas", value: "+1", categoryValue: "en-BS" },
  { caption: "البحرين", value: "+973", categoryValue: "ar-BH" },
  { caption: "বাংলাদেশ", value: "+880", categoryValue: "bn-BD" },
  { caption: "Беларусь", value: "+375", categoryValue: "be-BY" },
  { caption: "België", value: "+32", categoryValue: "nl-BE" },
  { caption: "Belize", value: "+501", categoryValue: "en-BZ" },
  { caption: "Bénin", value: "+229", categoryValue: "fr-BJ" },
  { caption: "འབྲུག", value: "+975", categoryValue: "dz-BT" },
  { caption: "Bolivia", value: "+591", categoryValue: "es-BO" },
  { caption: "Bosna i Hercegovina", value: "+387", categoryValue: "bs-BA" },
  { caption: "Botswana", value: "+267", categoryValue: "en-BW" },
  { caption: "Brasil", value: "+55", categoryValue: "pt-BR" },
  { caption: "بروني", value: "+673", categoryValue: "ms-BN" },
  { caption: "България", value: "+359", categoryValue: "bg-BG" },
  { caption: "Burkina Faso", value: "+226", categoryValue: "fr-BF" },
  { caption: "Uburundi", value: "+257", categoryValue: "rn-BI" },
  { caption: "កម្ពុជា", value: "+855", categoryValue: "km-KH" },
  { caption: "Cameroun", value: "+237", categoryValue: "fr-CM" },
  { caption: "Canada", value: "+1", categoryValue: "en-CA" },
  { caption: "Cabo Verde", value: "+238", categoryValue: "pt-CV" },
  { caption: "République centrafricaine", value: "+236", categoryValue: "fr-CF" },
  { caption: "Tchad", value: "+235", categoryValue: "fr-TD" },
  { caption: "Chile", value: "+56", categoryValue: "es-CL" },
  { caption: "中国", value: "+86", categoryValue: "zh-CN" },
  { caption: "Colombia", value: "+57", categoryValue: "es-CO" },
  { caption: "جزر القمر", value: "+269", categoryValue: "ar-KM" },
  { caption: "République du Congo", value: "+242", categoryValue: "fr-CG" },
  { caption: "Costa Rica", value: "+506", categoryValue: "es-CR" },
  { caption: "Hrvatska", value: "+385", categoryValue: "hr-HR" },
  { caption: "Cuba", value: "+53", categoryValue: "es-CU" },
  { caption: "Κύπρος", value: "+357", categoryValue: "el-CY" },
  { caption: "Česko", value: "+420", categoryValue: "cs-CZ" },
  { caption: "Danmark", value: "+45", categoryValue: "da-DK" },
  { caption: "جيبوتي", value: "+253", categoryValue: "fr-DJ" },
  { caption: "Dominica", value: "+1", categoryValue: "en-DM" },
  { caption: "República Dominicana", value: "+1", categoryValue: "es-DO" },
  { caption: "Ecuador", value: "+593", categoryValue: "es-EC" },
  { caption: "مصر", value: "+20", categoryValue: "ar-EG" },
  { caption: "El Salvador", value: "+503", categoryValue: "es-SV" },
  { caption: "Guinea Ecuatorial", value: "+240", categoryValue: "es-GQ" },
  { caption: "ኤርትራ", value: "+291", categoryValue: "ti-ER" },
  { caption: "Eesti", value: "+372", categoryValue: "et-EE" },
  { caption: "Eswatini", value: "+268", categoryValue: "en-SZ" },
  { caption: "ኢትዮጵያ", value: "+251", categoryValue: "am-ET" },
  { caption: "Fiji", value: "+679", categoryValue: "en-FJ" },
  { caption: "Suomi", value: "+358", categoryValue: "fi-FI" },
  { caption: "France", value: "+33", categoryValue: "fr-FR" },
  { caption: "Gabon", value: "+241", categoryValue: "fr-GA" },
  { caption: "Gambia", value: "+220", categoryValue: "en-GM" },
  { caption: "საქართველო", value: "+995", categoryValue: "ka-GE" },
  { caption: "Deutschland", value: "+49", categoryValue: "de-DE" },
  { caption: "Ghana", value: "+233", categoryValue: "en-GH" },
  { caption: "Ελλάδα", value: "+30", categoryValue: "el-GR" },
  { caption: "Grenada", value: "+1", categoryValue: "en-GD" },
  { caption: "Guatemala", value: "+502", categoryValue: "es-GT" },
  { caption: "Guinée", value: "+224", categoryValue: "fr-GN" },
  { caption: "Guiné-Bissau", value: "+245", categoryValue: "pt-GW" },
  { caption: "Guyana", value: "+592", categoryValue: "en-GY" },
  { caption: "Haïti", value: "+509", categoryValue: "fr-HT" },
  { caption: "Honduras", value: "+504", categoryValue: "es-HN" },
  { caption: "Magyarország", value: "+36", categoryValue: "hu-HU" },
  { caption: "Ísland", value: "+354", categoryValue: "is-IS" },
  { caption: "भारत", value: "+91", categoryValue: "hi-IN" },
  { caption: "Indonesia", value: "+62", categoryValue: "id-ID" },
  { caption: "ایران", value: "+98", categoryValue: "fa-IR" },
  { caption: "العراق", value: "+964", categoryValue: "ar-IQ" },
  { caption: "Ireland", value: "+353", categoryValue: "en-IE" },
  { caption: "ישראל", value: "+972", categoryValue: "he-IL" },
  { caption: "Italia", value: "+39", categoryValue: "it-IT" },
  { caption: "Jamaica", value: "+1", categoryValue: "en-JM" },
  { caption: "日本", value: "+81", categoryValue: "ja-JP" },
  { caption: "الأردن", value: "+962", categoryValue: "ar-JO" },
  { caption: "Қазақстан", value: "+7", categoryValue: "kk-KZ" },
  { caption: "Kenya", value: "+254", categoryValue: "en-KE" },
  { caption: "Kiribati", value: "+686", categoryValue: "en-KI" },
  { caption: "الكويت", value: "+965", categoryValue: "ar-KW" },
  { caption: "Кыргызстан", value: "+996", categoryValue: "ky-KG" },
  { caption: "ລາວ", value: "+856", categoryValue: "lo-LA" },
  { caption: "Latvija", value: "+371", categoryValue: "lv-LV" },
  { caption: "لبنان", value: "+961", categoryValue: "ar-LB" },
  { caption: "Lesotho", value: "+266", categoryValue: "en-LS" },
  { caption: "Liberia", value: "+231", categoryValue: "en-LR" },
  { caption: "ليبيا", value: "+218", categoryValue: "ar-LY" },
  { caption: "Liechtenstein", value: "+423", categoryValue: "de-LI" },
  { caption: "Lietuva", value: "+370", categoryValue: "lt-LT" },
  { caption: "Lëtzebuerg", value: "+352", categoryValue: "lb-LU" },
  { caption: "Madagasikara", value: "+261", categoryValue: "mg-MG" },
  { caption: "Malawi", value: "+265", categoryValue: "en-MW" },
  { caption: "Malaysia", value: "+60", categoryValue: "ms-MY" },
  { caption: "ދިވެހި", value: "+960", categoryValue: "dv-MV" },
  { caption: "Mali", value: "+223", categoryValue: "fr-ML" },
  { caption: "Malta", value: "+356", categoryValue: "mt-MT" },
  { caption: "Marshall Islands", value: "+692", categoryValue: "en-MH" },
  { caption: "موريتانيا", value: "+222", categoryValue: "ar-MR" },
  { caption: "Maurice", value: "+230", categoryValue: "en-MU" },
  { caption: "México", value: "+52", categoryValue: "es-MX" },
  { caption: "Micronesia", value: "+691", categoryValue: "en-FM" },
  { caption: "Republica Moldova", value: "+373", categoryValue: "ro-MD" },
  { caption: "Monaco", value: "+377", categoryValue: "fr-MC" },
  { caption: "Монгол", value: "+976", categoryValue: "mn-MN" },
  { caption: "Crna Gora", value: "+382", categoryValue: "sr-ME" },
  { caption: "المغرب", value: "+212", categoryValue: "ar-MA" },
  { caption: "Moçambique", value: "+258", categoryValue: "pt-MZ" },
  { caption: "မြန်မာ", value: "+95", categoryValue: "my-MM" },
  { caption: "Namibia", value: "+264", categoryValue: "en-NA" },
  { caption: "Nauru", value: "+674", categoryValue: "en-NR" },
  { caption: "नेपाल", value: "+977", categoryValue: "ne-NP" },
  { caption: "Nederland", value: "+31", categoryValue: "nl-NL" },
  { caption: "New Zealand", value: "+64", categoryValue: "en-NZ" },
  { caption: "Nicaragua", value: "+505", categoryValue: "es-NI" },
  { caption: "Niger", value: "+227", categoryValue: "fr-NE" },
  { caption: "Nigeria", value: "+234", categoryValue: "en-NG" },
  { caption: "Северна Македонија", value: "+389", categoryValue: "mk-MK" },
  { caption: "Norge", value: "+47", categoryValue: "nb-NO" },
  { caption: "عمان", value: "+968", categoryValue: "ar-OM" },
  { caption: "پاکستان", value: "+92", categoryValue: "ur-PK" },
  { caption: "Palau", value: "+680", categoryValue: "en-PW" },
  { caption: "فلسطين", value: "+970", categoryValue: "ar-PS" },
  { caption: "Panama", value: "+507", categoryValue: "es-PA" },
  { caption: "Papua New Guinea", value: "+675", categoryValue: "en-PG" },
  { caption: "Paraguay", value: "+595", categoryValue: "es-PY" },
  { caption: "Perú", value: "+51", categoryValue: "es-PE" },
  { caption: "Philippines", value: "+63", categoryValue: "en-PH" },
  { caption: "Polska", value: "+48", categoryValue: "pl-PL" },
  { caption: "Portugal", value: "+351", categoryValue: "pt-PT" },
  { caption: "قطر", value: "+974", categoryValue: "ar-QA" },
  { caption: "România", value: "+40", categoryValue: "ro-RO" },
  { caption: "Россия", value: "+7", categoryValue: "ru-RU" },
  { caption: "Rwanda", value: "+250", categoryValue: "rw-RW" },
  { caption: "Saint Kitts and Nevis", value: "+1", categoryValue: "en-KN" },
  { caption: "Saint Lucia", value: "+1", categoryValue: "en-LC" },
  { caption: "Saint Vincent and the Grenadines", value: "+1", categoryValue: "en-VC" },
  { caption: "Samoa", value: "+685", categoryValue: "en-WS" },
  { caption: "San Marino", value: "+378", categoryValue: "it-SM" },
  { caption: "São Tomé e Príncipe", value: "+239", categoryValue: "pt-ST" },
  { caption: "المملكة العربية السعودية", value: "+966", categoryValue: "ar-SA" },
  { caption: "Sénégal", value: "+221", categoryValue: "fr-SN" },
  { caption: "Србија", value: "+381", categoryValue: "sr-RS" },
  { caption: "Seychelles", value: "+248", categoryValue: "en-SC" },
  { caption: "Sierra Leone", value: "+232", categoryValue: "en-SL" },
  { caption: "新加坡", value: "+65", categoryValue: "en-SG" },
  { caption: "Slovensko", value: "+421", categoryValue: "sk-SK" },
  { caption: "Slovenija", value: "+386", categoryValue: "sl-SI" },
  { caption: "Solomon Islands", value: "+677", categoryValue: "en-SB" },
  { caption: "Soomaaliya", value: "+252", categoryValue: "so-SO" },
  { caption: "South Africa", value: "+27", categoryValue: "en-ZA" },
  { caption: "대한민국", value: "+82", categoryValue: "ko-KR" },
  { caption: "South Sudan", value: "+211", categoryValue: "en-SS" },
  { caption: "España", value: "+34", categoryValue: "es-ES" },
  { caption: "ශ්‍රී ලංකාව", value: "+94", categoryValue: "si-LK" },
  { caption: "السودان", value: "+249", categoryValue: "ar-SD" },
  { caption: "Suriname", value: "+597", categoryValue: "nl-SR" },
  { caption: "Sverige", value: "+46", categoryValue: "sv-SE" },
  { caption: "Schweiz", value: "+41", categoryValue: "de-CH" },
  { caption: "سوريا", value: "+963", categoryValue: "ar-SY" },
  { caption: "台灣", value: "+886", categoryValue: "zh-TW" },
  { caption: "Тоҷикистон", value: "+992", categoryValue: "tg-TJ" },
  { caption: "Tanzania", value: "+255", categoryValue: "sw-TZ" },
  { caption: "ประเทศไทย", value: "+66", categoryValue: "th-TH" },
  { caption: "Timor-Leste", value: "+670", categoryValue: "pt-TL" },
  { caption: "Togo", value: "+228", categoryValue: "fr-TG" },
  { caption: "Tonga", value: "+676", categoryValue: "en-TO" },
  { caption: "Trinidad and Tobago", value: "+1", categoryValue: "en-TT" },
  { caption: "تونس", value: "+216", categoryValue: "ar-TN" },
  { caption: "Türkiye", value: "+90", categoryValue: "tr-TR" },
  { caption: "Türkmenистан", value: "+993", categoryValue: "tk-TM" },
  { caption: "Tuvalu", value: "+688", categoryValue: "en-TV" },
  { caption: "Uganda", value: "+256", categoryValue: "en-UG" },
  { caption: "Україна", value: "+380", categoryValue: "uk-UA" },
  { caption: "الإمارات العربية المتحدة", value: "+971", categoryValue: "ar-AE" },
  { caption: "United Kingdom", value: "+44", categoryValue: "en-GB" },
  { caption: "United States", value: "+1", categoryValue: "en-US" },
  { caption: "Uruguay", value: "+598", categoryValue: "es-UY" },
  { caption: "Oʻzbekiston", value: "+998", categoryValue: "uz-UZ" },
  { caption: "Vanuatu", value: "+678", categoryValue: "en-VU" },
  { caption: "Città del Vaticano", value: "+39", categoryValue: "it-VA" },
  { caption: "Venezuela", value: "+58", categoryValue: "es-VE" },
  { caption: "Việt Nam", value: "+84", categoryValue: "vi-VN" },
  { caption: "اليمن", value: "+967", categoryValue: "ar-YE" },
  { caption: "Zambia", value: "+260", categoryValue: "en-ZM" },
  { caption: "Zimbabwe", value: "+263", categoryValue: "en-ZW" }
];
